import { HeroFeaturedBannerProps } from '@ahc-digital/component-library';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getDroplink } from 'src/shared/param-utils';
import { ReactElement } from 'react';
import { getKvpValue } from 'src/shared/field-utils';
import { B03HeroFeaturedBannerProps } from './B03HeroFeaturedBanner.types';

export function CreateHeroFeaturedBannerModel(
  props?: B03HeroFeaturedBannerProps
): HeroFeaturedBannerProps {
  const { params, fields } = props || {};
  const { renderText, renderLink } = useConditionalRendering();

  return {
    backgroundGradientLevel: getDroplink(params?.Gradient, '0'),
    backgroundImage: {
      src: fields?.BackgroundImage?.value?.src ?? '',
      alt: (fields?.BackgroundImage?.value?.alt as string) ?? '',
    },
    firstCTAIcon: getKvpValue(fields?.FirstCTAIcon),
    firstCTALink: renderLink(fields?.FirstCTA) as ReactElement,
    firstCTAStyle: getDroplink(params?.FirstCTAStyle),
    headline: renderText(fields?.Headline, { required: true }),
    mobileBackgroundImage: fields?.MobileBackgroundImage?.value?.src,
    secondCTAIcon: getKvpValue(fields?.SecondCTAIcon),
    secondCTALink: renderLink(fields?.SecondCTA) as ReactElement,
    secondCTAStyle: getDroplink(params?.SecondCTAStyle),
    taglineBottom: renderText(fields?.TaglineBottom),
    taglineTop: renderText(fields?.TaglineTop),
    bannerRatio: 'golden-ratio-half-landscape',
  };
}
